var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"text-lg bg-black text-white font-bold py-20-px rounded-xl w-full lg:w-80",class:_vm.btnStyle,domProps:{"textContent":_vm._s(_vm.text)},on:{"click":_vm.onClickEmit}})}
var staticRenderFns = []

export { render, staticRenderFns }